import { Observable } from 'rxjs';
import { first, ignoreElements, switchMap, tap } from 'rxjs/operators';
import { CartActions } from '@wearejh/m2-pwa-cart-gql';
import { ofType } from 'redux-observable';

export function algoliaAddToCart(action$: Observable<any>): Observable<never> {
    return action$.pipe(
        ofType<CartActions>('Cart.AddSuccess'),
        tap(() => {
            const params = new URLSearchParams(window.location.search);
            const objectId = params.get('objectId');

            // if no objectId is present, do nothing this should not be tracked by algolia
            if (!objectId) return;

            // Use localStorage to store the objectId array under the key 'algolia_basket'
            const key = 'algolia_basket';

            // Try to parse the existing list or start fresh
            let existing: string[] = [];

            try {
                existing = JSON.parse(localStorage.getItem(key) || '[]');

                if (!Array.isArray(existing)) {
                    existing = [];
                }
            } catch {
                existing = [];
            }

            // Add the objectId only if it's not already present
            if (!existing.includes(objectId)) {
                localStorage.setItem(key, JSON.stringify([...existing, objectId]));
            }
        }),

        // Wait for Cart.FetchSuccess before completing
        switchMap(() => action$.pipe(ofType<CartActions>('Cart.FetchSuccess'), first())),

        // Don't emit any actions from this epic
        ignoreElements(),
    );
}
